import React from "react";
import {Button, Form, Input, message, Modal, Select, Flex, Row, InputNumber } from "antd";
import { ScanOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import Can from '../../components/ability';
import SwitchShop from '../shop/switch-shop';
import Record from "./record";
import { getCurrentShopId } from "../shop/get-current-shop";
import { Html5Qrcode } from 'html5-qrcode';

const iconStyle = {
  fontSize: 28,
}

export default () => { 
    const [form] = Form.useForm();
    const [usedList, setUsedList] = React.useState([]);
    const [isOpen, setIsOpen] = React.useState(false);
    const [shopId, setShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            getVeriyRecord();
        }
    }, [shopId]);
    const submit = async () => {
        const values = await form.validateFields();
        values.shopId = await getCurrentShopId();
        console.log('Success:', values);

        await writeoff(values);
    };

    const writeoff = async ({id, shopId}) => {
        const response = await fetch('/api/writeoff', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id,
                shopId
            })
        });

        const result = await response.json();

        if(result?.success) {
            message.success('核销成功');
            getVeriyRecord();
        }else{
            message.error(result.data);
        }
    };

    // 唤起摄像头扫码
    const openScanModal = async () => { 
        let html5QrCode = null;
        let scanning = false;
        
        const modal = Modal.info({
            icon: null,
            title: '扫码核销',
            width: 500,
            content: (
                <div>
                    <div id="qr-reader" style={{ width: '100%', margin: 'auto' }}></div>
                    <p style={{ textAlign: 'center', marginTop: 10 }}>请将二维码放入框内，即可自动扫描</p>
                </div>
            ),
            onOk: () => {
                if (html5QrCode && scanning) {
                    html5QrCode.stop().catch((err) => {
                        console.log("Error stopping the scanner", err);
                    });
                }
            },
            onCancel: () => {
                if (html5QrCode && scanning) {
                    html5QrCode.stop().catch((err) => {
                        console.log("Error stopping the scanner", err);
                    });
                }
            }
        });

        // 初始化扫描器
        setTimeout(() => {
            Html5Qrcode.getCameras().then(devices => {
                if (devices && devices.length) {
                    const cameraId = devices[0].id;
                    html5QrCode = new Html5Qrcode("qr-reader");
                    
                    const config = {
                        fps: 10,
                        qrbox: { width: 250, height: 250 },
                        aspectRatio: 1.0
                    };

                    html5QrCode.start(
                        cameraId, 
                        config,
                        (decodedText, decodedResult) => {
                            // 扫描成功回调
                            console.log(`Code matched = ${decodedText}`, decodedResult);
                            // 停止扫描
                            html5QrCode.stop().then(() => {
                                scanning = false;
                                modal.destroy();
                                // 自动填写表单并提交
                                // form.setFieldsValue({ id: decodedText });
                                // 自动提交核销
                                submitWriteoff(decodedText);
                            }).catch((err) => {
                                console.log("Error stopping the scanner", err);
                            });
                        },
                        (errorMessage) => {
                            // 扫描失败回调
                            console.log(`QR Code scan error = ${errorMessage}`);
                        })
                        .then(() => {
                            scanning = true;
                        })
                        .catch((err) => {
                            console.log(`Unable to start scanning, error: ${err}`);
                            message.error('无法启动摄像头扫描');
                        });
                }
            }).catch(err => {
                console.log("Error getting cameras", err);
                message.error('无法获取摄像头设备');
            });
        }, 500);
    };

    const submitWriteoff = async (id) => {
        if (!shopId) return;
        await writeoff({id, shopId});
    };

    const getVeriyRecord = async () => {
        if (!shopId) return;
        const response = await fetch(`/api/verify/used-list?shopId=${shopId}`);
        const res = await response.json();
        
        if(res?.success) {
            setUsedList(res?.data?.rows || []);
        }
    }

    return ( 
        <div>
            <SwitchShop />
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <Can action="read" subject="order">
                    <NavItem text="扫码核销" onClick={openScanModal}>
                        <ScanOutlined style={iconStyle} />
                    </NavItem>
                </Can>
            </Row>
            <h2>输码核销</h2>
            <Form form={form}>
                <Form.Item label="核销码" name="id" rules={[{ required: true, message: '请输入核销码' }]}> 
                    <InputNumber step={1} style={{ width: '100%'}} />
                </Form.Item>
                <Flex justify="center" gap={20}>
                    <Button href="/">取消</Button>
                    <Button type='primary' onClick={submit}>核销</Button>
                </Flex>
            </Form>
            <h2>核销记录</h2>
            <Record dataSource={usedList} />
        </div>
    );
};